export const INIT_DURATION = 3; // (seconds) init/resize animation (appearing)
export const SWIM_SPEED = [20, 50]; // (pixels/seconds) common animation
export const SWIM_STEP = 50; // (pixels) common animation
export const CORNER_STEP = 1; // (rad) common animation
export const DOT_SIZES = [0.25, 0.75]; // dot size (% of screenSize = Math.min(window.width, window.height))
export const SIZE_FACTOR = 2; // factor of reducing dot
export const OFFSET_FACTOR = 0.5; // (0...1) factor of hiding dots
